<template>
	<div>
		<ModalBase
			container-class="text-white bg-black h-full w-full"
			ref="fullImageModal">
			<div class="flex justify-between w-full h-full">
				<div class="w-10">
					<!--	 Empty div to center the image		-->
				</div>
				<img
					fit="contain"
					class="place-self-center max-w-[80%] max-h-full md:w-10/12"
					:src="imageSrc" />
				<div class="w-10 place-self-start pt-2">
					<IconsFontAwesome
						icon="fa-solid fa-xmark"
						class="hover:cursor-pointer"
						@click="closeModal" />
				</div>
			</div>
		</ModalBase>
	</div>
</template>

<script setup>
	defineProps({
		imageSrc: String,
	})

	const fullImageModal = ref(null)

	const openModal = () => fullImageModal.value.openModal()

	const closeModal = () => fullImageModal.value.closeModal()

	defineExpose({
		openModal,
	})
</script>

<style lang="scss" scoped></style>
